import { maskCPF, maskPhone } from '../utils/formaters';
export const groupDtoToGroup = (groups) => {
    const seen = new Set();
    const uniqueGroups = groups
        .filter(dto => {
        const duplicate = seen.has(dto.GrupoID);
        seen.add(dto.GrupoID);
        return !duplicate;
    })
        .map(dto => ({
        id: dto.GrupoID,
        name: dto.Nome,
        group: dto.GrupoEconomico,
        economicGroup: dto.GrupoEconomico,
    }));
    return uniqueGroups;
};
export const groupListDtoToGroup = (groups) => {
    const seen = new Set();
    const uniqueGroups = groups.grupos
        .filter(dto => {
        const duplicate = seen.has(dto.id);
        seen.add(dto.id);
        return !duplicate;
    })
        .map(dto => ({
        id: dto.id,
        name: dto.nome,
        group: dto.grupo_economico,
        economicGroup: dto.grupo_economico,
    }));
    return uniqueGroups || [];
};
export const UserListDtoToUserList = (users) => {
    return {
        pageCount: users.TotalPaginas,
        rows: users.TotalTamanho,
        itens: users.Data.map(dto => ({
            id: dto.cpf,
            name: dto?.nome,
            cpf: maskCPF(dto?.cpf),
            email: dto?.email,
            phone: maskPhone(dto?.telefone),
            group: groupDtoToGroup(dto?.grupos) || [],
        })),
    };
};
export const UserDtoToCreateUser = (dto) => {
    return {
        name: dto.nomeCompleto,
        email: dto.email,
        cpf: maskCPF(dto.cpf),
        date: dto.dataNascimento,
        phone: maskPhone(dto.telefone),
        bases: groupDtoToGroup(dto.gruposEconomicos),
        permissions: dto.permissoes.flatMap(item => item.AreaAcesso),
    };
};
